// API Configuration
const config = {
  // Use environment variable if available, otherwise default to localhost
  API_URL: process.env.REACT_APP_API_URL || 'http://89.167.27.41:8000/api',
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'http://89.167.27.41:8000',
  
  // API endpoints
  endpoints: {
    // Authentication
    AUTH_REGISTER: '/auth/register/',
    AUTH_LOGIN: '/auth/login/',
    AUTH_PROFILE: '/auth/profile/',
    AUTH_REFRESH: '/auth/token/refresh/',
    
    // Brands
    BRANDS: '/brands/',
    BRAND_DETAIL: (id) => `/brands/${id}/`,
    BRAND_ADD_MEMBER: (id) => `/brands/${id}/add_member/`,
    BRAND_REMOVE_MEMBER: (id) => `/brands/${id}/remove_member/`,
    
    // Posts
    POSTS: '/posts/',
    POST_DETAIL: (id) => `/posts/${id}/`,
    POST_PUBLISH: (id) => `/posts/${id}/publish/`,
    GENERATE_CONTENT: '/posts/generate-content/',
    GENERATE_WEEK: '/posts/generate-week/',
    CADENCE_RATIO: '/posts/cadence-ratio/',
    BRAND_CADENCE: (id) => `/brands/${id}/cadence/`,

    // Social Accounts
    SOCIAL_ACCOUNTS: '/social-accounts/',
    SOCIAL_ACCOUNT_DETAIL: (id) => `/social-accounts/${id}/`,
    
    // Platform Connections
    CONNECT_LINKEDIN: '/connect/linkedin/',
    CONNECT_FACEBOOK: '/connect/facebook/',
    CONNECT_INSTAGRAM: '/connect/instagram/',
    CONNECT_X: '/connect/x/',
    
    // OAuth 2.0 init endpoints (redirects, not API calls)
    OAUTH_LINKEDIN_INIT: '/api/auth/linkedin/init/',
    OAUTH_LINKEDIN_ANALYTICS_INIT: '/api/auth/linkedin-analytics/init/',
    OAUTH_X_INIT: '/api/auth/x/init/',
    
    // Ideas
    IDEAS: '/ideas/',
    IDEA_DETAIL: (id) => `/ideas/${id}/`,

    // Influence Inbox
    INFLUENCE: '/influence/',
    INFLUENCE_DETAIL: (id) => `/influence/${id}/`,
    INFLUENCE_CONVERT: (id) => `/influence/${id}/convert-to-idea/`,

    // Analytics
    ANALYTICS: '/analytics/',
    ANALYTICS_BRAND_SUMMARY: '/analytics/brand_summary/',
    ANALYTICS_INSIGHTS: '/analytics/insights/',
    REFRESH_ANALYTICS: '/refresh-analytics/',

    // New: Command Center endpoints
    DASHBOARD: '/dashboard/',
    PIPELINE: '/pipeline/',
    CALENDAR_DATA: '/calendar/',

    // New: Connections / Audience
    CONNECTIONS: '/connections/',
    CONNECTION_DETAIL: (id) => `/connections/${id}/`,
    CONNECTIONS_IMPORT: '/connections/import/',
    CONNECTIONS_STATS: '/connections/stats/',
    CONNECTIONS_RECLASSIFY: '/connections/reclassify/',
  }
};

export default config;
